import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import MoreVert from "@mui/icons-material/MoreVert";
import RSSIcon from "@mui/icons-material/RssFeed";
import {
  Box,
  Checkbox,
  Chip,
  CircularProgress,
  FormControlLabel,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { checkMultipleArticleExistence } from "../../api/MyLibrary/MyFolders.api";
import { getAlertSettings } from "../../api/MyLibrary/TOCAlerts.api";
import {
  authorJsonFacetQuery,
  basicSearchForCounts,
  basicSearchMain,
  basicSearchQuery,
  getJgateNextAISummary,
  getJgateNextHistoryAISummary,
  jsonFacetQuery,
  removeSummaryHeading,
  staticAuthorFacetData,
  staticFacetData,
  staticSubjectFacetData,
  subjectJsonFacetQuery,
} from "../../api/Search/BasicSearch.api";
import {
  getPersonalLibraryCollection,
  getPersonalLibraryCollectionSRP,
  personalCoreCount,
} from "../../api/Search/CollectionApi";
import { setSearch } from "../../api/Search/SetSearch";
import api from "../../api/endpoints";
import { queryConstructor } from "../../api/formQuery";
import { getBulkLinkRecords } from "../../api/linkResolverApi";
import { usagelogApi } from "../../api/usageReportApi";
import SplitButton from "../../components/Switch/SplitButton";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import {
  resetAppliedQueries,
  updateQueries,
} from "../../store/slice/appliedQueries";
import {
  clearAuthorSearchTerm,
  updateAuthorSearchResults,
  updateAuthorSort,
  updateInstitutionFilter,
} from "../../store/slice/authorFinderSlice";
import {
  clearAllFilters,
  clearAllFiltersValue,
  clearLimits,
  clearPublicationFilter,
  clearSearchedAuthor,
  clearSJRandABDCFilters,
  updateAllFilter,
  updateArticleSource,
  updateAuthor,
  updateConsortiaCollection,
  updateCountryOfPublication,
  updateCountryOfPublishingAuthor,
  updateDateset,
  updateEarlyOnline,
  updateInstitution,
  updateJournal,
  updateJournalRank,
  updateMonthFrom,
  updateMyLibraryCollection,
  updateOnosCollection,
  updateOpenAccess,
  updatePersonalLibrary,
  updatePublisher,
  updateResearch,
  updateResearcher,
  updateRetractedArticle,
  updateSort,
  updateSourceIndex,
  updateSourceIndexType,
  updateSourceType,
  updateSpeaker,
  updateSubject,
  updateYearFrom,
} from "../../store/slice/filterSlice";
import { updateSubjectFilter as authorUpdateSubject } from "../../store/slice/authorFinderSlice";
import { updateQuery } from "../../store/slice/queryForCountSlice";
import {
  clearClassificationNum,
  clearCPCClassificationNum,
  clearMeshKeyword,
  clearSearchTerm,
  clearSubstances,
  updateAdvSearchQuery,
  updateAlertSettingData,
  updateAll,
  updateAllFacets,
  updateAuthorFacets,
  updateAuthorFiltersLoader,
  updateClassificationNumber,
  updateDataType,
  updateFullText,
  updateLinkToDisplay,
  updateMeshKeyword,
  updateNewSearchStatus,
  updateOtherFiltersLoader,
  updatePage,
  updateRow,
  updateSavedArticles,
  updateSearchResults,
  updateSearchTerm,
  updateSubjectFacets,
  updateSubjectFilterLoader,
} from "../../store/slice/searchSlice";
import {
  clearAllSetSearch,
  updateSetInNumber,
  updateSetSearchQuery,
  updateSetSearchStatus,
} from "../../store/slice/setSearch";
import { SaverArticlesType } from "../../types/interface";
import {
  getQueryParams,
  removeOperatorFromEnd,
  showIsProfileToast,
} from "../../utils/helper";
import { CustomTooltip } from "../MyLibrary/MyAlerts/Alerts.style";
import { SearchHistory, stringSanitizer } from "./SearchHistory";
import { searchHistoryStyles as sx } from "./SearchHistory.styles";
import SearchHistoryAlert from "./SearchHistoryAlert";
import SearchHistoryMenu from "./SearchHistoryMenu";
import { Delete, Save } from "@mui/icons-material";
import {
  deleteSearchHistory,
  savedSearchAlert,
} from "../../api/searchHistoryapi";
import { notify } from "../../utils/Notify";
import SaveSearchModal from "./SaveSearchModal";
import { checkAlertTopicAvailability } from "../../api/MyLibrary/SearchAlerts.api";
import {
  searchHistorySuccess,
  updateSearchHistoryResults,
} from "../../store/slice/searchHistorySlice";
import QueryBuilder from "./QueryBuilder";
import { Colors } from "../../utils/constants";
import { setModal } from "../../store/slice/modalSlice";
import { clearAllFilters as clearAllAuthorFilters } from "../../store/slice/authorFinderSlice";
import {
  enterAIMode,
  exitAIMode,
  setAISummary,
  setAISummaryLoading,
  setArticleIds,
} from "../../store/slice/aiModeSlice";

import type { SearchMode } from "./SearchHistory";
import { checkAiCredits } from "../../api/checkAiCreditsApi";

type Props = {
  searchHistory: SearchHistory[];
  fetchSearchHistory: () => Promise<void>;
  setSearchMode: React.Dispatch<React.SetStateAction<SearchMode>>;
  searchMode: SearchMode;
};

export async function checkArticleExistance(
  dataArray: any[],
  userId: string,
  dispatch: any,
) {
  if (!Array.isArray(dataArray)) return;
  const articleData = new FormData();

  const articleIds =
    Array.isArray(dataArray) && dataArray?.map((x: any) => x?.article_id);
  articleData.append("profile_id", userId);
  articleData.append("article_ids", articleIds.toString());

  const checkArticleExistance =
    await checkMultipleArticleExistence(articleData);

  const filter_is_saved =
    Array.isArray(checkArticleExistance) &&
    checkArticleExistance.filter(
      (x: SaverArticlesType) => x.is_saved !== false,
    );
  dispatch(updateSavedArticles(filter_is_saved));
}

export async function linkToDisplay(
  dataArray: any[],
  customerData: any,
  dispatch: any,
) {
  if (!Array.isArray(dataArray)) return;
  let formData = new FormData();

  let data = dataArray?.map((obj: any) => {
    let object: any = {
      customer_id: customerData?.informaticscustomer_id,
      article_id: obj?.article_id,
      consortia_virtualid: customerData?.consortia_virtualid,
      resource_type: obj?.resource_type == 27 ? 8 : obj?.resource_type,
      access_type:
        obj?.data_type === "Books"
          ? obj?.access_type_id
          : obj?.article_open_status,
      is_oa_article: obj?.fulltext || false,
    };

    if (obj?.articledoi) {
      object.article_doi = obj?.articledoi;
    }

    if (obj?.resourceissue_id) {
      object.resourceissue_id = obj?.resourceissue_id;
    }

    return object;
  });

  let formApiData = {
    data,
  };

  formData.append("detailed_json", JSON.stringify(formApiData));
  const response = await getBulkLinkRecords(formData);

  if (response?.message === "Ok") {
    dispatch(updateLinkToDisplay(response?.data));
  }
}

export async function findAlertTypeSetting(
  dataArray: any[],
  userId: string,
  dispatch: any,
) {
  try {
    // const resourcemaster_ids =
    //   Array.isArray(dataArray) &&
    //   dataArray
    //     ?.map((x: any) => x?.resourcemaster_id)

    const resourcemaster_ids =
      Array.isArray(dataArray) &&
      dataArray
        ?.map((x: any) => x?.resourcemaster_id)
        .filter((id): id is number => id !== null && id !== undefined);

    if (Array.isArray(resourcemaster_ids)) {
      const alertSettingData = await getAlertSettings(
        userId,
        resourcemaster_ids,
      );
      let alertDataRes = alertSettingData.data.data[0][0];
      dispatch(updateAlertSettingData(alertDataRes));
    }
  } catch (err) {
    console.log(err);
  }
}

const HistoryTable = ({
  searchHistory,
  fetchSearchHistory,
  searchMode,
  setSearchMode,
}: Props) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const userId = useAppSelector((state) => state.login.user_id);
  const profileData = useAppSelector((state) => state.login);
  const customerData = useAppSelector(
    ({ customer }) => customer.customerDetails,
  );
  const { user_id, csrf_token } = useAppSelector((state) => state.login);

  console.log("searchHistory", searchHistory);

  const [selectedSearches, setSelectedSearches] = useState<SearchHistory[]>([]);
  const [multiple, setMultiple] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openRSSModal, setOpenRSSModal] = useState<boolean>(false);
  const [selectedMenuHistory, setSelectedMenuHistory] =
    useState<SearchHistory>();
  const [isSearching, setIsSearching] = useState<boolean>(false);
  const [rowNumber, setRowNumber] = useState<null | number>(null);
  const [saveSearchModal, setSaveSearchModal] = useState(false);
  const [alertTopic, setAlertTopic] = useState("");
  const [singleRow, setSingleRow] = useState<any>();
  const profileData1 = useAppSelector(
    (state) => state.customer.customerDetails,
  );
  // const [searchMode, setSearchMode] = useState<SearchMode>("boolean");

  const isAICustomer = customerData?.display_ai_in_jgate;

  const logBasicSearchUsageData = (usageActionID: any, searchtypeId?: any) => {
    const user_ipv4_address =
      sessionStorage.getItem("user_ipv4_address") || null;

    const userMasterId = profileData.user_id ? profileData.user_id : null;
    const informaticscustomerId = profileData.informaticscustomer_id
      ? profileData.informaticscustomer_id
      : null;
    const consortiamasterId =
      profileData1 && profileData1.consortiamaster_id
        ? profileData1.consortiamaster_id
        : null;
    const sessionKey = profileData.session_key ? profileData.session_key : null;
    const isAISearch = isAICustomer && searchtypeId === 9 ? true : false;
    usagelogApi(
      userMasterId,
      informaticscustomerId,
      consortiamasterId,
      usageActionID,
      null,
      searchtypeId,
      null,
      null,
      null,
      null,
      // profileData.ip_v4,
      user_ipv4_address,
      null,
      sessionKey,
      1,
      null,
      0,
      null,
      isAISearch,
    );
  };

  const handleKeywordClick = async (
    dirtyString: string,
    searchURL: string,
    searchType: string,
    row_number: number,
    aiUser_query?: string,
  ) => {
    if (isSearching) return;

    const searchTerm = stringSanitizer(dirtyString);

    if (searchTerm.toLocaleUpperCase().includes("#S")) {
      handleSetSearchClick(searchURL);
      return;
    }
    if (!searchTerm) {
      dispatch(clearSearchTerm());
      setIsSearching(false);
      return;
    }
    const advanceSearchTerms = [
      "resourcemaster_id",
      "title_fz",
      "yearfrom",
      "mesh_keywords",
      "keywords_fz",
      "author_address_fz",
      "issn",
      "articledoi",
      "author_all_fz",
      "resource_name_tk",
    ];
    const anotherSetOfAdvSearchTerms = [
      "(resourcemaster_id",
      "(title_fz",
      "(yearfrom",
      "(keywords_fz",
      "(author_address_fz",
      "(issn",
      "(articledoi",
      "(author_all_fz",
      "(resource_name_tk",
      "(titleKeywordsAbs",
      "((title_fz",
      "((yearfrom",
      "((keywords_fz",
      "((author_address_fz",
      "((issn",
      "((articledoi",
      "((author_all_fz",
      "((resource_name_tk",
      "((titleKeywordsAbs",
    ];
    let isAdvanceSearchTerm = advanceSearchTerms.some((term) =>
      new RegExp(`\\b${term}\\b`).test(dirtyString),
    );
    try {
      //DF-2088 (added newly)
      dispatch(clearAllSetSearch());
      dispatch(clearLimits());
      dispatch(clearAuthorSearchTerm());
      dispatch(clearAllAuthorFilters());
      dispatch(resetAppliedQueries());
      dispatch(clearMeshKeyword());
      dispatch(clearSubstances());
      dispatch(clearClassificationNum());
      dispatch(clearCPCClassificationNum());
      //old filters
      dispatch(clearSearchTerm());
      dispatch(clearAllFilters());
      dispatch(clearAllFiltersValue());
      dispatch(clearPublicationFilter());

      const missingQueryObj = {
        rows: 15,
        op_mode: "and",
      };

      const fullTextQuery = await queryConstructor({
        "fq__(fulltext": `true OR acl_group=(${profileData.informaticscustomer_id}))`,
        ...missingQueryObj,
        sort:
          searchType === "J-Gate InsightAI"
            ? "score desc"
            : "dateofpublication desc",
        datsearchtype_id:
          searchType === "Advanced Search"
            ? "2"
            : searchType === "Basic Search"
              ? "1"
              : searchType === "Author Search"
                ? "3"
                : searchType === "J-Gate InsightAI"
                  ? "9"
                  : "1",
      });
      const allTextQuery = await queryConstructor({
        ...missingQueryObj,
        sort:
          searchType === "J-Gate InsightAI"
            ? "score desc"
            : "dateofpublication desc",
        datsearchtype_id:
          searchType === "Advanced Search"
            ? "2"
            : searchType === "Basic Search"
              ? "1"
              : searchType === "Author Search"
                ? "3"
                : searchType === "J-Gate InsightAI"
                  ? "9"
                  : "1",
      });

      // replace the "&" with "~_~"
      let replacedQuery = searchURL.replace(/ & /g, ` ~_~ `);

      // fq__profileuser_id should be removed form the query
      let fqProfileQuery = `&fq__profileuser_id=${profileData.user_id}`;

      let actualFullTextQuery = fullTextQuery + "&" + replacedQuery;
      let actualAllextQuery =
        replacedQuery.replace(
          `&fq__(fulltext=true OR acl_group=(${profileData.informaticscustomer_id}))`,
          "",
        ) +
        "&" +
        allTextQuery;
      const queryParams = getQueryParams(actualAllextQuery);
      let countApiCall, recordApiCall;

      if (queryParams?.fq__profileuser_id) {
        countApiCall = personalCoreCount;
        // recordApiCall = getPersonalLibraryCollection;
        recordApiCall = getPersonalLibraryCollectionSRP;
      } else {
        countApiCall = basicSearchForCounts;
        //recordApiCall = basicSearchMain;
        recordApiCall = basicSearchQuery;
      }

      actualFullTextQuery = actualFullTextQuery.replace(fqProfileQuery, "");
      actualAllextQuery = actualAllextQuery.replace(fqProfileQuery, "");

      dispatch(
        updateQuery({
          fullTextQuery: actualFullTextQuery,
          allTextQuery: actualAllextQuery,
        }),
      );

      const queryParamsKeys = Object.keys(queryParams);
      let isAdv = anotherSetOfAdvSearchTerms.some((term) =>
        queryParamsKeys.includes(term),
      );
      isAdvanceSearchTerm = isAdvanceSearchTerm || isAdv;

      updateQueryParamsToRedux(
        queryParams,
        dirtyString,
        isAdvanceSearchTerm,
        row_number,
        searchType,
        aiUser_query,
      );
      //updateNewFormateQueryParamsToRedux(row_number);

      const fullTextData = await recordApiCall(actualFullTextQuery);
      const allText = await countApiCall(actualAllextQuery);
      const fulltext = await countApiCall(actualFullTextQuery);

      const articleIdsForGenSummary = (allText?.docs || [])
        .slice(0, 10)
        .map((item: any) => item?.article_id)
        .filter(Boolean)
        .join(",");

      // dispatch(setArticleIds(articleIdsForGenSummary));

      dispatch(updateSearchResults(fullTextData));
      dispatch(updateFullText(true));
      dispatch(updateAll(false));
      dispatch(updateRow(15));
      dispatch(updatePage(1));
      // dispatch(updateSort("dateofpublication desc"));
      const update_sort =
        searchType === "J-Gate InsightAI"
          ? "score desc"
          : "dateofpublication desc";
      dispatch(updateSort(update_sort));
      dispatch(updateNewSearchStatus(true));

      if (isAdvanceSearchTerm) {
        let advSearchObj: any = {};
        let arr = [...advanceSearchTerms, ...anotherSetOfAdvSearchTerms];

        arr.forEach((term) => {
          if (queryParams[term]) {
            advSearchObj[term] = queryParams[term];
          }
        });

        const advQuery = await queryConstructor(advSearchObj);
        let decodedQuery = decodeURIComponent(advQuery);
        //dispatch(updateAdvSearchQuery(decodedQuery));
      }

      const userQuery = aiUser_query;

      setIsSearching(false);
      const titleKeywordsAbs = queryParams?.titleKeywordsAbs;
      let x = dirtyString.replace(
        /author_address_fz:|title_fz:|keywords_fz:|author_all_fz:|issn:|resource_name_tk|articledoi:|resourcemaster_id:|yearfrom:/gi,
        "",
      );
      if (searchType === "Author Search" && fullTextData?.docs) {
        dispatch(exitAIMode());
        dispatch(updateAuthorSearchResults(fullTextData));
        navigate("/authorfindersearch?searchterm=" + searchTerm);
        dispatch(updateAuthorSort("dateofpublication desc"));
        return;
      }
      if (searchType === "J-Gate InsightAI") {
        if (fullTextData?.docs) {
          navigate("/basicSearchScreen?searchterm=" + searchTerm, {
            state: {
              searchTerm: titleKeywordsAbs,
              userQuery,
              fullTextQuery,
              searchURL,
              allCount: allText?.hits,
              fullCount: fulltext?.hits,
              from: "searchHistory",
              fullTextData,
              searchMode: "semantic",
            },
          });
        }
        dispatch(
          enterAIMode({
            userQuery: aiUser_query ?? "",
            aiQuery: titleKeywordsAbs ?? "",
            initialAllCount: allText?.hits ?? 0,
            initialFullCount: fulltext?.hits ?? 0,
            articleIds: articleIdsForGenSummary,
          }),
        );

        // Check Summary AI Credits
        const hasSummaryAccess = await checkAiCredits("insight_hub_summary");

        if (!hasSummaryAccess) {
          dispatch(setAISummary(""));
          return;
        }
        dispatch(setAISummaryLoading(true));

        try {
          const summary = await getJgateNextHistoryAISummary({
            articleIds: articleIdsForGenSummary,
            userQuery: aiUser_query ?? "",
          });

          const updatedSummary = removeSummaryHeading(summary);
          dispatch(setAISummary(updatedSummary));
        } catch (error) {
          dispatch(setAISummary(""));
          console.error(error);
        } finally {
          dispatch(setAISummaryLoading(false));
        }
      } else {
        dispatch(exitAIMode());
        if (fullTextData?.docs) {
          navigate("/basicSearchScreen?searchterm=" + searchTerm, {
            //navigate("/basicSearchScreen?searchterm=" + titleKeywordsAbs, {
            state: {
              searchTerm: x,
              fullTextQuery: fullTextQuery,
              allQuery: searchURL,
              allCount: allText?.hits,
              fullCount: fulltext?.hits,
              from: "searchHistory",
            },
          });
        }
      }

      // const fullTextData = await recordApiCall(actualFullTextQuery);
      // const allText = await countApiCall(actualAllextQuery);
      // const fulltext = await countApiCall(actualFullTextQuery);

      dispatch(updateSubjectFilterLoader(true));
      dispatch(updateAuthorFiltersLoader(true));
      dispatch(updateOtherFiltersLoader(true));

      await checkArticleExistance(fullTextData?.docs, userId, dispatch);
      await findAlertTypeSetting(fullTextData?.docs, userId, dispatch);
      await linkToDisplay(fullTextData?.docs, customerData, dispatch);

      if (queryParams?.fq__profileuser_id) {
        //Jsonfacets
        const subjectFacetData = await getPersonalLibraryCollectionSRP(
          actualFullTextQuery,
          staticSubjectFacetData,
        );
        dispatch(updateSubjectFacets(subjectFacetData?.jsonfacets));
        dispatch(updateSubjectFilterLoader(false));
        const authorFacetData = await getPersonalLibraryCollectionSRP(
          actualFullTextQuery,
          staticAuthorFacetData,
        );
        dispatch(updateAuthorFacets(authorFacetData?.jsonfacets));
        dispatch(updateAuthorFiltersLoader(false));
        const allFacetData = await getPersonalLibraryCollectionSRP(
          actualFullTextQuery,
          staticFacetData,
        );
        dispatch(updateAllFacets(allFacetData?.jsonfacets));
        dispatch(updateOtherFiltersLoader(false));
      } else {
        //JsonFacets
        const subjectFacetData =
          await subjectJsonFacetQuery(actualFullTextQuery);
        dispatch(updateSubjectFacets(subjectFacetData?.jsonfacets));
        dispatch(updateSubjectFilterLoader(false));
        const authorFacetData = await authorJsonFacetQuery(actualFullTextQuery);
        dispatch(updateAuthorFacets(authorFacetData?.jsonfacets));
        dispatch(updateAuthorFiltersLoader(false));
        const otherFacetData = await jsonFacetQuery(actualFullTextQuery);
        dispatch(updateAllFacets(otherFacetData?.jsonfacets));
        dispatch(updateOtherFiltersLoader(false));
      }

      // dispatch(
      //   updateQuery({
      //     fullTextQuery: actualFullTextQuery,
      //     allTextQuery: actualAllextQuery,
      //   })
      // );

      // const queryParamsKeys = Object.keys(queryParams);
      // let isAdv = anotherSetOfAdvSearchTerms.some((term) =>
      //   queryParamsKeys.includes(term)
      // );
      // isAdvanceSearchTerm = isAdvanceSearchTerm || isAdv;

      // updateQueryParamsToRedux(queryParams, dirtyString, isAdvanceSearchTerm);

      // dispatch(updateSearchResults(fullTextData));
      // dispatch(updateFullText(true));
      // dispatch(updateAll(false));
      // dispatch(updateRow(15));
      // dispatch(updatePage(1));
      // dispatch(updateSort("dateofpublication desc"));
      // dispatch(updateNewSearchStatus(true));

      // if (isAdvanceSearchTerm) {
      //   let advSearchObj: any = {};
      //   let arr = [...advanceSearchTerms, ...anotherSetOfAdvSearchTerms];

      //   arr.forEach((term) => {
      //     if (queryParams[term]) {
      //       advSearchObj[term] = queryParams[term];
      //     }
      //   });

      //   const advQuery = await queryConstructor(advSearchObj);
      //   let decodedQuery = decodeURIComponent(advQuery);
      //   dispatch(updateAdvSearchQuery(decodedQuery));
      // }

      //console.log("queryParams", queryParams);
      //   setIsSearching(false);
      //   const titleKeywordsAbs = queryParams?.titleKeywordsAbs;
      //   let x = dirtyString.replace(
      //     /author_address_fz:|title_fz:|keywords_fz:|author_all_fz:|issn:|resource_name_tk|articledoi:|resourcemaster_id:|yearfrom:/gi,
      //     ""
      //   );
      //   if (searchType === "Author Search" && fullTextData?.docs) {
      //     dispatch(updateAuthorSearchResults(fullTextData));
      //     navigate("/authorfindersearch?searchterm=" + searchTerm);
      //     dispatch(updateAuthorSort("dateofpublication desc"));
      //     return;
      //   }

      //   if (fullTextData?.docs) {
      //     // navigate("/basicSearchScreen?searchterm=" + searchTerm, {
      //     navigate("/basicSearchScreen?searchterm=" + searchTerm, {
      //       state: {
      //         searchTerm: x,
      //         fullTextQuery: fullTextQuery,
      //         allQuery: searchURL,
      //         allCount: allText?.hits,
      //         fullCount: fulltext?.hits,
      //       },
      //     });
      //   }
    } catch (error) {
      setIsSearching(false);
    }
  };

  async function handleSetSearchClick(searchUrl: string) {
    let replacedQuery = searchUrl.replace(/ & /g, ` ~_~ `);
    const queryParams = getQueryParams(replacedQuery);
    //const queryParams = getQueryParams(searchUrl);
    Object.assign(queryParams, { sort: "dateofpublication desc" });
    const isOnlyConsortiaAccess = customerData?.product_type === "7";
    if (isOnlyConsortiaAccess) {
      Object.assign(queryParams, {
        fq__acl_group: customerData.consortia_filter,
      });
    }
    const query = await queryConstructor(queryParams);
    const response = await setSearch(query, "fulltext");
    // await linkToDisplay(response?.docs, customerData, dispatch);

    dispatch(updateSearchResults(response));
    queryParams?.set_number_in &&
      dispatch(updateSetInNumber(queryParams?.set_number_in));

    dispatch(
      updateAllFilter({
        key: "search-term",
        value: queryParams?.set_number_in,
      }),
    );

    dispatch(
      updateQueries({
        key: "searchTerm",
        value: queryParams?.set_number_in,
      }),
    );

    if (queryParams?.fq__yearfrom) {
      dispatch(updateYearFrom(queryParams.fq__yearfrom));
      dispatch(
        updateQueries({
          key: "currentYear",
          value: queryParams.fq__yearfrom,
        }),
      );
    }

    if (queryParams?.fq__data_type) {
      // Document type filter
      const dataType = queryParams?.fq__data_type
        .split("OR")
        .map((x: string) => {
          let str = x;
          str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          return str;
        });
      console.log(queryParams?.fq__data_type.split("OR"));
      dispatch(updateSourceType(dataType));

      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(dataType) &&
        dataType.forEach((val: string) => {
          appliedFilter.push({
            key: "data_type",
            value: val,
          });
        });
      dispatch(updateQueries(appliedFilter));
      dispatch(updateAllFilter(appliedFilter));
    }

    if (queryParams?.fq__fulltext) {
      dispatch(updateOpenAccess(true));
    }

    if (queryParams?.fq__has_datasets) {
      dispatch(updateDateset(true));
    }

    if (queryParams?.fq__is_retracted) {
      dispatch(updateRetractedArticle(true));
    }

    if (queryParams?.fq__pubmed_article) {
      dispatch(updateSourceIndex(true));
    }

    if (queryParams?.fq__subjects_name_l3) {
      let subjectQuery = queryParams?.fq__subjects_name_l3
        .split("OR")
        .map((x: string) => {
          let str = x;
          str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          return str;
        });

      // Update subject filter
      dispatch(updateSubject(subjectQuery));
      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(subjectQuery) &&
        subjectQuery.forEach((val: string) => {
          appliedFilter.push({
            key: "subject",
            value: val,
          });
        });
      dispatch(updateQueries(appliedFilter));
      dispatch(updateAllFilter(appliedFilter));
    }

    if (queryParams?.fq__early_online) {
      dispatch(updateEarlyOnline(true));
      dispatch(
        updateQueries({
          key: "earlyOnline",
          value: true,
        }),
      );
    }

    if (queryParams?.fq__dateofpublication) {
      dispatch(updateMonthFrom(queryParams.fq__dateofpublication));
    }

    // Updating Collection filter
    if (queryParams?.fq__acl_group) {
      if (queryParams.fq__acl_group === customerData?.my_library_filter) {
        dispatch(updateMyLibraryCollection(true));
        dispatch(
          updateQueries({
            key: "myLibraryCollection",
            value: true,
          }),
        );
      } else if (queryParams.fq__acl_group === customerData?.consortia_filter) {
        dispatch(updateConsortiaCollection(true));
        dispatch(
          updateQueries({
            key: "consortiaSubscriptions",
            value: true,
          }),
        );
      }
    }

    if (queryParams?.fq__profileuser_id) {
      dispatch(updatePersonalLibrary(true));
      dispatch(
        updateQueries({
          key: "myPersonalLibraryCollection",
          value: true,
        }),
      );
    }

    if (queryParams?.fq__is_onos_resource) {
      dispatch(updateOnosCollection(true));
      dispatch(
        updateQueries({
          key: "onosCollection",
          value: true,
        }),
      );
    }

    if (queryParams?.fq__resource_type) {
      let arr = queryParams?.fq__resource_type
        .replace(/[^a-zA-Z0-9\s]/g, "")
        .split(" OR ")
        ?.map((str: string) => Number(str));

      dispatch(updateDataType(arr));
    }

    if (queryParams?.fq__authors_tk) {
      const authorParam = queryParams?.fq__authors_tk
        .split("OR")
        .map((x: string) => {
          let str = x;
          str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          return str;
        });
      dispatch(updateAuthor(authorParam));
      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(authorParam) &&
        authorParam.forEach((val: string) => {
          appliedFilter.push({
            key: "author",
            value: val,
          });
        });
      dispatch(updateAllFilter(appliedFilter));
      dispatch(updateQueries(appliedFilter));
    }

    if (queryParams?.fq__speakers) {
      const speakerParam = queryParams?.fq__speakers
        .split("OR")
        .map((x: string) => {
          let str = x;
          str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          return str;
        });
      dispatch(updateSpeaker(speakerParam));

      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(speakerParam) &&
        speakerParam.forEach((val: string) => {
          appliedFilter.push({
            key: "speaker",
            value: val,
          });
        });
      dispatch(updateQueries(appliedFilter));
      dispatch(updateAllFilter(appliedFilter));
    }

    if (queryParams?.fq__guide_name_tk) {
      const guideParam = queryParams?.fq__guide_name_tk
        .split("OR")
        .map((x: string) => {
          let str = x;
          str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          return str;
        });
      dispatch(updateResearch(guideParam));

      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(guideParam) &&
        guideParam.forEach((val: string) => {
          appliedFilter.push({
            key: "research",
            value: val,
          });
        });
      dispatch(updateQueries(appliedFilter));
      dispatch(updateAllFilter(appliedFilter));
    }

    if (queryParams?.fq__researcher_tk) {
      const researcherParam = queryParams?.fq__researcher_tk
        .split("OR")
        .map((x: string) => {
          let str = x;
          str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          return str;
        });
      dispatch(updateResearcher(researcherParam));

      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(researcherParam) &&
        researcherParam.forEach((val: string) => {
          appliedFilter.push({
            key: "researcher",
            value: val,
          });
        });
      dispatch(updateQueries(appliedFilter));
      dispatch(updateAllFilter(appliedFilter));
    }

    if (queryParams?.fq__journal_name) {
      const journalParam = queryParams?.fq__journal_name
        .split("OR")
        .map((x: string) => {
          let str = x;
          str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          return str;
        });
      dispatch(updateJournal(journalParam));

      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(journalParam) &&
        journalParam.forEach((val: string) => {
          appliedFilter.push({
            key: "journal",
            value: val,
          });
        });
      dispatch(updateQueries(appliedFilter));
      dispatch(updateAllFilter(appliedFilter));
    }

    if (queryParams?.fq__primary_publisher_country) {
      const primaryPublisherParam = queryParams?.fq__primary_publisher_country
        .split("OR")
        .map((x: string) => {
          let str = x;
          str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          return str;
        });
      dispatch(updateCountryOfPublication(primaryPublisherParam));

      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(primaryPublisherParam) &&
        primaryPublisherParam.forEach((val: string) => {
          appliedFilter.push({
            key: "countryOfPublication",
            value: val,
          });
        });
      dispatch(updateQueries(appliedFilter));
      dispatch(updateAllFilter(appliedFilter));
    }

    if (queryParams?.fq__publisher_name) {
      const publisherNameParam = queryParams?.fq__publisher_name
        .split("OR")
        .map((x: string) => {
          let str = x;
          // str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          str = str.trim().replace(/["]/g, "").replace("~_~", "&");
          return str;
        });
      dispatch(updatePublisher(publisherNameParam));

      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(publisherNameParam) &&
        publisherNameParam.forEach((val: string) => {
          appliedFilter.push({
            key: "publisher",
            value: val,
          });
        });
      dispatch(updateQueries(appliedFilter));
      dispatch(updateAllFilter(appliedFilter));
    }

    if (queryParams?.fq__author_address) {
      const authorAddressParam = queryParams?.fq__author_address
        .split("OR")
        .map((x: string) => {
          let str = x;
          str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          return str;
        });
      dispatch(updateInstitution(authorAddressParam));

      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(authorAddressParam) &&
        authorAddressParam.forEach((val: string) => {
          appliedFilter.push({
            key: "institutions",
            value: val,
          });
        });
      dispatch(updateQueries(appliedFilter));
      dispatch(updateAllFilter(appliedFilter));
    }

    if (queryParams?.fq__filter_metrix) {
      const journalRankParam = queryParams?.fq__filter_metrix
        .split("OR")
        .map((x: string) => {
          let str = x;
          str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          return str;
        });
      dispatch(updateJournalRank(journalRankParam));

      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(journalRankParam) &&
        journalRankParam.forEach((val: string) => {
          appliedFilter.push({
            key: "journalRank",
            value: val,
          });
        });
      dispatch(updateQueries(appliedFilter));
      dispatch(updateAllFilter(appliedFilter));
    }

    if (queryParams?.fq__resource_source_index) {
      const SourceIndexTypeParam = queryParams?.fq__resource_source_index
        .split("OR")
        .map((x: string) => {
          let str = x;
          str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          return str;
        });
      dispatch(updateSourceIndexType(SourceIndexTypeParam));

      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(SourceIndexTypeParam) &&
        SourceIndexTypeParam.forEach((val: string) => {
          appliedFilter.push({
            key: "sourceIndexType",
            value: val,
          });
        });
      dispatch(updateQueries(appliedFilter));
      dispatch(updateAllFilter(appliedFilter));
    }

    if (queryParams?.fq__author_country_name) {
      const countryOfPublishingAuthorParam =
        queryParams?.fq__author_country_name.split("OR").map((x: string) => {
          let str = x;
          str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          return str;
        });
      dispatch(updateCountryOfPublishingAuthor(countryOfPublishingAuthorParam));

      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(countryOfPublishingAuthorParam) &&
        countryOfPublishingAuthorParam.forEach((val: string) => {
          appliedFilter.push({
            key: "countryOfPublishingAuthor",
            value: val,
          });
        });
      dispatch(updateQueries(appliedFilter));
      dispatch(updateAllFilter(appliedFilter));
    }

    dispatch(updateSetSearchQuery(query));
    dispatch(updateSetSearchStatus(true));
    const allText = await setSearch(query, "all", "count");
    const fullText = await setSearch(query, "fulltext", "count");

    if (response?.docs) {
      navigate("/basicSearchScreen?searchterm=" + queryParams?.set_number_in, {
        state: {
          allCount: allText?.hits,
          fullCount: fullText?.hits,
          from: "searchHistory",
        },
      });
    }

    await linkToDisplay(response?.docs, customerData, dispatch);
    dispatch(updateSubjectFilterLoader(true));
    dispatch(updateAuthorFiltersLoader(true));
    dispatch(updateOtherFiltersLoader(true));

    //JsonFacets
    const subjectFacetData = await setSearch(
      query,
      "fulltext",
      "all",
      "true",
      false,
      "all",
      1,
    );
    dispatch(updateSubjectFacets(subjectFacetData?.jsonfacets));
    dispatch(updateSubjectFilterLoader(false));
    const authorFacetData = await setSearch(
      query,
      "fulltext",
      "all",
      "true",
      false,
      "all",
      2,
    );
    dispatch(updateAuthorFacets(authorFacetData?.jsonfacets));
    dispatch(updateAuthorFiltersLoader(false));
    const otherFacetData = await setSearch(
      query,
      "fulltext",
      "all",
      "true",
      false,
      "all",
      3,
    );
    dispatch(updateAllFacets(otherFacetData?.jsonfacets));
    dispatch(updateOtherFiltersLoader(false));
  }

  function formatSearchQuery(rawQuery: string): string {
    if (!rawQuery?.trim()) return "";
    let formatted = rawQuery;
    formatted = formatted.replace(
      /\(\s*title_fz=([^\s()]+)\s+OR\s+keywords_fz=\1\s*\)/gi,
      "$1",
    );
    formatted = formatted.replace(
      /author_address_fz=|title_fz=|keywords_fz=|author_all_fz=|issn=|articledoi=|resourcemaster_id=|yearfrom=|titleKeywordsAbs=/gi,
      "",
    );
    return formatted.trim();
  }

  const updateQueryParamsToRedux = (
    queryParams: any,
    dirtyString: any,
    isAdvSearchTerm?: boolean,
    row_number?: number,
    searchType?: string,
    aiUser_query?: string,
  ) => {
    // Updating search term
    const titleKeywordsAbs = queryParams?.titleKeywordsAbs;
    titleKeywordsAbs && dispatch(updateSearchTerm(titleKeywordsAbs));
    const aiUserQuery = aiUser_query;
    const SEARCH_TYPE = "J-Gate InsightAI";

    if (
      queryParams?.author_address_fz ||
      queryParams?.title_fz ||
      queryParams?.keywords_fz ||
      queryParams?.author_all_fz ||
      queryParams?.issn ||
      queryParams?.isbn ||
      queryParams?.articledoi ||
      queryParams?.resourcemaster_id ||
      queryParams?.yearfrom ||
      queryParams?.resource_name_tk ||
      queryParams?.mesh_keywords ||
      queryParams?.application_no ||
      queryParams?.classification_no ||
      queryParams?.cpc_no ||
      queryParams?.substances ||
      queryParams?.author_country_name ||
      queryParams?.casestudy_no ||
      (isAdvSearchTerm && !aiUserQuery)
    ) {
      // let x = removeDuplicateTerms(dirtyString);
      if (searchType === SEARCH_TYPE) {
        dispatch(
          updateAllFilter({
            key: "search-term",
            value: aiUserQuery,
          }),
        );
        dispatch(updateSort("score desc"));
      } else if (titleKeywordsAbs != null && titleKeywordsAbs !== "") {
        dispatch(
          updateAllFilter({
            key: "search-term",
            // value: titleKeywordsAbs,
            value: formatSearchQuery(titleKeywordsAbs),
          }),
        );
      }
      if (queryParams?.mesh_keywords) {
        const queryString = `mesh_keywords=${queryParams?.mesh_keywords}`;
        //dispatch(updateMeshKeyword(queryString));
        dispatch(updateAdvSearchQuery(queryString));
        dispatch(
          updateAllFilter({
            key: "search-term",
            // value: titleKeywordsAbs,
            value: formatSearchQuery(queryParams?.mesh_keywords),
          }),
        );
      }
      if (queryParams?.application_no) {
        const queryString = `application_no=${queryParams?.application_no}`;
        //dispatch(updateMeshKeyword(queryString));
        dispatch(updateAdvSearchQuery(queryString));
        dispatch(
          updateAllFilter({
            key: "application_no",
            // value: titleKeywordsAbs,
            value: formatSearchQuery(queryParams?.application_no),
          }),
        );
      }
      if (queryParams?.classification_no) {
        const queryString = `classification_no=${queryParams?.classification_no}`;
        //dispatch(updateMeshKeyword(queryString));
        dispatch(updateAdvSearchQuery(queryString));
        dispatch(
          updateAllFilter({
            key: "IPC Classic No- ",
            // key: "classification_no",
            // value: titleKeywordsAbs,
            value: formatSearchQuery(queryParams?.classification_no),
          }),
        );
      }

      if (queryParams?.cpc_no) {
        const queryString = `cpc_no=${queryParams?.cpc_no}`;
        //dispatch(updateMeshKeyword(queryString));
        dispatch(updateAdvSearchQuery(queryString));
        dispatch(
          updateAllFilter({
            key: "CPC Classic No- ",
            // key: "cpc_no",
            // value: titleKeywordsAbs,
            value: formatSearchQuery(queryParams?.cpc_no),
          }),
        );
      }

      if (queryParams?.substances) {
        const queryString = `substances=${queryParams?.substances}`;
        //dispatch(updateMeshKeyword(queryString));
        dispatch(updateAdvSearchQuery(queryString));
        dispatch(
          updateAllFilter({
            key: "search-term",
            // value: titleKeywordsAbs,
            value: formatSearchQuery(queryParams?.substances),
          }),
        );
      }

      if (queryParams?.casestudy_no) {
        const queryString = `casestudy_no=${queryParams?.casestudy_no}`;
        //dispatch(updateMeshKeyword(queryString));
        dispatch(updateAdvSearchQuery(queryString));
        dispatch(
          updateAllFilter({
            key: "search-term",
            // value: titleKeywordsAbs,
            value: formatSearchQuery(queryParams?.casestudy_no),
          }),
        );
      }
      if (queryParams?.author_country_name) {
        const queryString = `author_country_name=${queryParams?.author_country_name}`;
        //dispatch(updateMeshKeyword(queryString));
        dispatch(updateAdvSearchQuery(queryString));
        dispatch(
          updateAllFilter({
            key: "search-term",
            // value: titleKeywordsAbs,
            value: formatSearchQuery(queryParams?.author_country_name),
          }),
        );
      }

      if (queryParams?.yearfrom) {
        const queryString = `yearfrom=${queryParams?.yearfrom}`;
        dispatch(updateAdvSearchQuery(queryString));
        dispatch(
          updateAllFilter({
            key: "yearFrom",
            // value: queryParams.yearfrom,
            value: formatSearchQuery(queryParams.yearfrom),
          }),
        );
      }

      if (queryParams?.title_fz) {
        const queryString = `title_fz=${queryParams.title_fz}`;
        dispatch(updateAdvSearchQuery(queryString));
        //dispatch(updateTitle(queryParams?.title_fz));
        dispatch(
          updateAllFilter({
            key: "title_fz",
            // value: queryParams.title_fz,
            value: formatSearchQuery(queryParams.title_fz),
          }),
        );
      }

      if (queryParams?.author_all_fz) {
        console.log("queryParams", queryParams?.author_all_fz);
        const queryString = `author_all_fz=${queryParams?.author_all_fz}`;
        dispatch(updateAdvSearchQuery(queryString));
        dispatch(
          updateAllFilter({
            key: "author_all_fz",
            // value: queryParams.author_all_fz,
            value: formatSearchQuery(queryParams.author_all_fz),
          }),
        );
      }

      if (queryParams?.author_address_fz) {
        const queryString = `author_address_fz=${queryParams?.author_address_fz}`;
        dispatch(updateAdvSearchQuery(queryString));
        //dispatch(updateAuthorAddress(queryParams?.author_address_fz));
        //dispatch(updateAdvSearchQuery(queryParams?.articledoi));
        dispatch(
          updateAllFilter({
            key: "author_address_fz",
            // value: queryParams.author_address_fz,
            value: formatSearchQuery(queryParams.author_address_fz),
          }),
        );
      }

      if (queryParams?.issn) {
        const queryString = `issn=${queryParams?.issn}`;
        dispatch(updateAdvSearchQuery(queryString));
        //dispatch(updateISSN(queryParams?.issn));
        dispatch(
          updateAllFilter({
            key: "issn",
            // value: queryParams.issn,
            value: formatSearchQuery(queryParams.issn),
          }),
        );
      }

      if (queryParams?.isbn) {
        const queryString = `isbn=${queryParams?.isbn}`;
        dispatch(updateAdvSearchQuery(queryString));
        // dispatch(updateISBN(queryParams?.isbn));
        dispatch(
          updateAllFilter({
            key: "isbn",
            // value: queryParams.isbn,
            value: formatSearchQuery(queryParams.isbn),
          }),
        );
      }

      if (queryParams?.articledoi) {
        const queryString = `articledoi=${queryParams?.articledoi}`;
        dispatch(updateAdvSearchQuery(queryString));
        dispatch(
          updateAllFilter({
            key: "articledoi",
            // value: queryParams.articledoi,
            value: formatSearchQuery(queryParams.articledoi),
          }),
        );
      }

      if (queryParams?.resource_name_tk) {
        //dispatch(updateAdvSearchQuery(queryParams?.resource_name_tk));
        const queryString = `resource_name_tk=${queryParams?.resource_name_tk}`;
        dispatch(updateAdvSearchQuery(queryString));
        dispatch(
          updateAllFilter({
            key: "resource_name_tk",
            // value: queryParams.resource_name_tk,
            value: formatSearchQuery(queryParams.resource_name_tk),
          }),
        );
      }

      if (queryParams?.["(title_fz"]) {
        const queryString = `(title_fz=${queryParams?.["(title_fz"]}`; // Add parentheses around the value as it includes conditions
        dispatch(updateAdvSearchQuery(queryString));
        dispatch(
          updateAllFilter({
            key: "title_fz/keywords_fz",
            // value: queryParams.resource_name_tk,
            value: formatSearchQuery(queryString)
              .replace(")", "")
              .replace(")", ""),
          }),
        );
      }
      // else {
      //   dispatch(
      //     updateAllFilter({
      //       key: "search-term",
      //       value: `#S${row_number}`,
      //     })
      //   );
      // }
    } else {
      if (searchType === SEARCH_TYPE) {
        dispatch(
          updateAllFilter({
            key: "search-term",
            value: aiUserQuery,
          }),
        );
        dispatch(updateSort("score desc"));
      } else {
        if (titleKeywordsAbs?.replace("titleKeywordsAbs=", "")) {
          dispatch(
            updateAllFilter({
              key: "search-term",
              value: formatSearchQuery(titleKeywordsAbs),
            }),
          );
        }
      }
    }
    dispatch(
      updateQueries({
        key: "searchTerm",
        value: titleKeywordsAbs,
      }),
    );
    //Update independent filters - fix for df 2113
    if (queryParams?.fq__fulltext) {
      dispatch(updateOpenAccess(true));
    }

    if (queryParams?.fq__has_datasets) {
      dispatch(updateDateset(true));
    }

    if (queryParams?.fq__is_retracted) {
      dispatch(updateRetractedArticle(true));
    }

    if (queryParams?.fq__pubmed_article) {
      dispatch(updateSourceIndex(true));
    }

    // Updating publication date filter
    if (queryParams?.fq__early_online) {
      dispatch(updateEarlyOnline(true));
      dispatch(
        updateQueries({
          key: "earlyOnline",
          value: true,
        }),
      );
    }

    if (queryParams?.fq__yearfrom) {
      dispatch(updateYearFrom(queryParams.fq__yearfrom));
      dispatch(
        updateQueries({
          key: "currentYear",
          value: queryParams.fq__yearfrom,
        }),
      );
      // dispatch(
      //   updateAllFilter({
      //     key: "currentYear",
      //     value: queryParams.fq__yearfrom,
      //   })
      // );
    }

    if (queryParams?.fq__dateofpublication) {
      dispatch(updateMonthFrom(queryParams.fq__dateofpublication));
    }

    if (queryParams?.fq__article_source) {
      dispatch(updateArticleSource(queryParams.fq__article_source));
      dispatch(
        updateAllFilter({
          key: "article_source",
          value: queryParams.fq__article_source,
        }),
      );
    }

    if (queryParams?.fq__classification_no) {
      dispatch(updateClassificationNumber(queryParams.fq__classification_no));
      dispatch(
        updateAllFilter({
          // key: "Classification Number",
          key: "IPC Classic No- ",
          value: queryParams.fq__classification_no,
        }),
      );
    }

    if (queryParams?.fq__cpc_no) {
      dispatch(updateClassificationNumber(queryParams.fq__cpc_no));
      dispatch(
        updateAllFilter({
          key: "CPC Classic No- ",
          // key: "fq__cpc_no",
          value: queryParams.fq__cpc_no,
        }),
      );
    }

    // Updating Collection filter
    if (queryParams?.fq__acl_group) {
      if (queryParams.fq__acl_group === customerData?.my_library_filter) {
        dispatch(updateMyLibraryCollection(true));
        dispatch(
          updateQueries({
            key: "myLibraryCollection",
            value: true,
          }),
        );
      } else if (queryParams.fq__acl_group === customerData?.consortia_filter) {
        dispatch(updateConsortiaCollection(true));
        dispatch(
          updateQueries({
            key: "consortiaSubscriptions",
            value: true,
          }),
        );
      }
    }

    if (queryParams?.fq__profileuser_id) {
      dispatch(updatePersonalLibrary(true));
      dispatch(
        updateQueries({
          key: "myPersonalLibraryCollection",
          value: true,
        }),
      );
    }

    if (queryParams?.fq__is_onos_resource) {
      dispatch(updateOnosCollection(true));
      dispatch(
        updateQueries({
          key: "onosCollection",
          value: true,
        }),
      );
    }

    // Updating resource type
    if (queryParams?.fq__resource_type) {
      let arr = queryParams?.fq__resource_type
        .replace(/[^a-zA-Z0-9\s]/g, "")
        .split(" OR ")
        ?.map((str: string) => Number(str));

      dispatch(updateDataType(arr));
    }

    // Updating Filters
    if (queryParams?.fq__data_type) {
      // Document type filter
      const dataType = queryParams?.fq__data_type
        .split("OR")
        .map((x: string) => {
          let str = x;
          str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          return str;
        });
      console.log(queryParams?.fq__data_type.split("OR"));
      dispatch(updateSourceType(dataType));

      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(dataType) &&
        dataType.forEach((val: string) => {
          appliedFilter.push({
            key: "data_type",
            value: val,
          });
        });
      dispatch(updateQueries(appliedFilter));
      dispatch(updateAllFilter(appliedFilter));
    }

    if (queryParams?.fq__subjects_name_l3) {
      let subjectQuery = queryParams?.fq__subjects_name_l3
        .split("OR")
        .map((x: string) => {
          let str = x;
          str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          return str;
        });

      // Update subject filter
      dispatch(updateSubject(subjectQuery));
      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(subjectQuery) &&
        subjectQuery.forEach((val: string) => {
          appliedFilter.push({
            key: "subject",
            value: val,
          });
        });
      dispatch(updateQueries(appliedFilter));
      dispatch(updateAllFilter(appliedFilter));
    }

    if (queryParams?.subjects_name_l3) {
      let subjectQuery = queryParams?.subjects_name_l3
        .split("OR")
        .map((x: string) => {
          let str = x;
          str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          return str;
        });

      // Update subject filter
      dispatch(authorUpdateSubject(subjectQuery));
      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(subjectQuery) &&
        subjectQuery.forEach((val: string) => {
          appliedFilter.push({
            key: "subject",
            value: val,
          });
        });
      dispatch(updateQueries(appliedFilter));
      dispatch(updateAllFilter(appliedFilter));
    }

    if (queryParams?.fq__authors_tk) {
      const authorParam = queryParams?.fq__authors_tk
        .split("OR")
        .map((x: string) => {
          let str = x;
          str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          return str;
        });
      dispatch(updateAuthor(authorParam));
      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(authorParam) &&
        authorParam.forEach((val: string) => {
          appliedFilter.push({
            key: "author",
            value: val,
          });
        });
      dispatch(updateAllFilter(appliedFilter));
      dispatch(updateQueries(appliedFilter));
    }

    if (queryParams?.author_address) {
      const authorParam = queryParams?.author_address
        .split("OR")
        .map((x: string) => {
          let str = x;
          str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          return str;
        });
      //dispatch(updateAuthor(authorParam));
      dispatch(updateInstitutionFilter(authorParam));
      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(authorParam) &&
        authorParam.forEach((val: string) => {
          appliedFilter.push({
            key: "author",
            value: val,
          });
        });
      dispatch(updateAllFilter(appliedFilter));
      dispatch(updateQueries(appliedFilter));
    }

    if (queryParams?.fq__speakers) {
      const speakerParam = queryParams?.fq__speakers
        .split("OR")
        .map((x: string) => {
          let str = x;
          str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          return str;
        });
      dispatch(updateSpeaker(speakerParam));

      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(speakerParam) &&
        speakerParam.forEach((val: string) => {
          appliedFilter.push({
            key: "speaker",
            value: val,
          });
        });
      dispatch(updateQueries(appliedFilter));
      dispatch(updateAllFilter(appliedFilter));
    }

    if (queryParams?.fq__guide_name_tk) {
      const guideParam = queryParams?.fq__guide_name_tk
        .split("OR")
        .map((x: string) => {
          let str = x;
          str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          return str;
        });
      dispatch(updateResearch(guideParam));

      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(guideParam) &&
        guideParam.forEach((val: string) => {
          appliedFilter.push({
            key: "research",
            value: val,
          });
        });
      dispatch(updateQueries(appliedFilter));
      dispatch(updateAllFilter(appliedFilter));
    }

    if (queryParams?.fq__researcher_tk) {
      const researcherParam = queryParams?.fq__researcher_tk
        .split("OR")
        .map((x: string) => {
          let str = x;
          str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          return str;
        });
      dispatch(updateResearcher(researcherParam));

      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(researcherParam) &&
        researcherParam.forEach((val: string) => {
          appliedFilter.push({
            key: "researcher",
            value: val,
          });
        });
      dispatch(updateQueries(appliedFilter));
      dispatch(updateAllFilter(appliedFilter));
    }

    if (queryParams?.fq__journal_name) {
      const journalParam = queryParams?.fq__journal_name
        .split("OR")
        .map((x: string) => {
          let str = x;
          str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          return str;
        });
      dispatch(updateJournal(journalParam));

      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(journalParam) &&
        journalParam.forEach((val: string) => {
          appliedFilter.push({
            key: "journal",
            value: val,
          });
        });
      dispatch(updateQueries(appliedFilter));
      dispatch(updateAllFilter(appliedFilter));
    }

    if (queryParams?.fq__primary_publisher_country) {
      const primaryPublisherParam = queryParams?.fq__primary_publisher_country
        .split("OR")
        .map((x: string) => {
          let str = x;
          str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          return str;
        });
      dispatch(updateCountryOfPublication(primaryPublisherParam));

      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(primaryPublisherParam) &&
        primaryPublisherParam.forEach((val: string) => {
          appliedFilter.push({
            key: "countryOfPublication",
            value: formatSearchQuery(val),
          });
        });
      dispatch(updateQueries(appliedFilter));
      dispatch(updateAllFilter(appliedFilter));
    }

    if (queryParams?.fq__publisher_name) {
      const publisherNameParam = queryParams?.fq__publisher_name
        .split("OR")
        .map((x: string) => {
          let str = x;
          // str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          str = str.trim().replace(/["]/g, "").replace("~_~", "&");
          return str;
        });
      dispatch(updatePublisher(publisherNameParam));

      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(publisherNameParam) &&
        publisherNameParam.forEach((val: string) => {
          appliedFilter.push({
            key: "publisher",
            value: val,
          });
        });
      dispatch(updateQueries(appliedFilter));
      dispatch(updateAllFilter(appliedFilter));
    }

    if (queryParams?.fq__author_address) {
      const authorAddressParam = queryParams?.fq__author_address
        .split("OR")
        .map((x: string) => {
          let str = x;
          str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          return str;
        });
      dispatch(updateInstitution(authorAddressParam));

      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(authorAddressParam) &&
        authorAddressParam.forEach((val: string) => {
          appliedFilter.push({
            key: "institutions",
            value: val,
          });
        });
      dispatch(updateQueries(appliedFilter));
      dispatch(updateAllFilter(appliedFilter));
    }

    if (queryParams?.fq__filter_metrix) {
      const journalRankParam = queryParams?.fq__filter_metrix
        .split("OR")
        .map((x: string) => {
          let str = x;
          str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          return str;
        });
      dispatch(updateJournalRank(journalRankParam));

      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(journalRankParam) &&
        journalRankParam.forEach((val: string) => {
          appliedFilter.push({
            key: "journalRank",
            value: val,
          });
        });
      dispatch(updateQueries(appliedFilter));
      dispatch(updateAllFilter(appliedFilter));
    }

    if (queryParams?.fq__resource_source_index) {
      const SourceIndexTypeParam = queryParams?.fq__resource_source_index
        .split("OR")
        .map((x: string) => {
          let str = x;
          str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          return str;
        });
      dispatch(updateSourceIndexType(SourceIndexTypeParam));

      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(SourceIndexTypeParam) &&
        SourceIndexTypeParam.forEach((val: string) => {
          appliedFilter.push({
            key: "sourceIndexType",
            value: val,
          });
        });
      dispatch(updateQueries(appliedFilter));
      dispatch(updateAllFilter(appliedFilter));
    }

    if (queryParams?.fq__author_country_name) {
      const countryOfPublishingAuthorParam =
        queryParams?.fq__author_country_name.split("OR").map((x: string) => {
          let str = x;
          str = str.trim().replace(/[()"]/g, "").replace("~_~", "&");
          return str;
        });
      dispatch(updateCountryOfPublishingAuthor(countryOfPublishingAuthorParam));

      // to Update the breadcurm
      let appliedFilter: any[] = [];
      Array.isArray(countryOfPublishingAuthorParam) &&
        countryOfPublishingAuthorParam.forEach((val: string) => {
          appliedFilter.push({
            key: "countryOfPublishingAuthor",
            value: val,
          });
        });
      dispatch(updateQueries(appliedFilter));
      dispatch(updateAllFilter(appliedFilter));
    }
  };

  const handleMenuClick =
    (row: SearchHistory) => (e: React.MouseEvent<HTMLElement>) => {
      e.stopPropagation();
      setSelectedMenuHistory(row);
      setAnchorEl(e.currentTarget);
    };

  const handleRSSClick =
    (row: SearchHistory) => (e: React.MouseEvent<HTMLElement>) => {
      e.stopPropagation();

      const profileStatus = sessionStorage.getItem("isProfileUser");
      if (profileStatus !== "true") {
        showIsProfileToast("Please login as profile user to set alert");
        return;
      }

      setSelectedMenuHistory(row);
      setOpenRSSModal(true);
    };

  const handleUsageLog = (data: any) => {
    const serachTypeId =
      data === "Basic Search"
        ? 1
        : data === "Advanced Search"
          ? 2
          : data === "Author Search"
            ? 3
            : data === "Browse By"
              ? 4
              : data === "Library Search"
                ? 5
                : data === "Consortium Search"
                  ? 6
                  : data === "Search History"
                    ? 7
                    : data === "J-Gate InsightAI"
                      ? 9
                      : null;
    logBasicSearchUsageData(96, serachTypeId);
  };

  function removeDuplicateTerms(searchTerm: string) {
    if (!searchTerm) return "";
    // Split the search term into individual terms
    if (searchTerm.includes("title_fz") && searchTerm.includes("keywords_fz")) {
      let term = searchTerm.replace(
        /author_address_fz:|title_fz:|keywords_fz:|author_all_fz:|issn:|articledoi:|resourcemaster_id:|yearfrom:/gi,
        "",
      );
      const splitedArr = term?.split(/\s+(?![^()]*\))/);
      let newArr = [];

      for (let obj of splitedArr) {
        if (obj.startsWith("(") && obj.endsWith(")")) {
          let arr1 = obj?.slice(1, -1)?.replace(/[()]/g, "").split(" ");

          let arr2: string[] = [];
          for (let i = 0; i < arr1.length; i++) {
            if (!arr2.includes(arr1[i])) {
              arr2.push(arr1[i]);
            }
          }

          let val = `${removeOperatorFromEnd(arr2.join(" "))}`;
          newArr.push(val);
        } else {
          newArr.push(obj);
        }
      }
      for (let i = 0; i < newArr.length; i++) {
        if (newArr[i] === newArr[i + 2]) {
          newArr.splice(i + 1, 2);
        }
      }
      term = newArr.join(" ");
      return term;
    } else {
      let term = searchTerm
        .replace(
          /author_address_fz:|title_fz:|keywords_fz:|author_all_fz:|issn:|articledoi:|resourcemaster_id:|yearfrom:/gi,
          "",
        )
        .replace("is_retracted", "retracted")
        .replace("fulltext", "openaccess")
        .replace("has_datasets", "datasets")
        .replace("pubmed_article", "pubmed")
        .replace("filter_metrix", "journal_ranking")
        .replace("authors_tk", "authors")
        .replace("subjects_name_l3", "subjects_name")
        .replace("data_type", "document_type")
        .replace("primary_publisher_country", "publisher_country")
        .replace("researcher_tk", "researcher")
        .replace("guide_name_tk", "guide_name")
        .replace("author_address", "institution")
        .replace("cpc_no", "CPC Classif No")
        .replace("cpc_no", "CPC Classif No")
        .replace("classification_no", "IPC Classif No")
        .replace("fq__classification_no", "IPC Classif No")
        .replace("Classification No", "IPC Classif No");

      return term;
    }
  }

  function handleSelected(item: SearchHistory) {
    if (
      selectedSearches
        ?.map((item) => {
          return item?.search_id;
        })
        ?.includes(item?.search_id)
    ) {
      setSelectedSearches(
        selectedSearches?.filter((obj) => obj?.search_id !== item?.search_id),
      );
    } else {
      setSelectedSearches([...selectedSearches, item]);
    }
  }

  function handleSelectAll() {
    if (
      selectedSearches?.length ===
      searchHistory?.filter((obj) => obj?.is_delete === false)?.length
    ) {
      setSelectedSearches([]);
    } else {
      setSelectedSearches(
        searchHistory?.filter((obj) => obj?.is_delete === false),
      );
    }
  }
  //Check if its Dev Environment
  const isDev = api.baseApi === "https://betaapi.jgatenext.com";

  const handleSingleDelete = async (row: any) => {
    const search_log_ids = row?.search_id;
    await deleteSearchHistory(search_log_ids, csrf_token).then(() => {
      fetchSearchHistory();
      notify("success", "Search Deleted");
      setSelectedSearches((prev) =>
        prev.filter((item) => item.search_id !== search_log_ids),
      );
    });
  };

  const handleMultilpeDelete = async () => {
    const search_log_ids = selectedSearches
      ?.map((item: any) => {
        return item?.search_id;
      })
      ?.join(",");

    await deleteSearchHistory(search_log_ids, csrf_token).then(() => {
      fetchSearchHistory();
      setSelectedSearches([]);
      notify("success", "Selected Searches Deleted");
    });
  };

  const handleSaveSearchHistory = async () => {
    if (!alertTopic) {
      notify("error", "Alert Topic is required!");
      return;
    }
    logBasicSearchUsageData(94);
    if (sessionStorage.getItem("isProfileUser") === "true") {
      const usersearchlog_id = singleRow?.search_id;

      const profileuser_id = user_id;
      const is_saved = true;

      // Check the alert topic availability
      const isTopicAvailable = await checkAlertTopicAvailability(alertTopic);
      if (isTopicAvailable === "Alert Topic already exists") {
        notify("error", isTopicAvailable);
        return;
      }

      try {
        let multipleData: any[] = [];
        multiple &&
          selectedSearches?.forEach((ele: any, index: number) => {
            multipleData.push({
              usermaster_id: profileuser_id,
              usersearchlog_id: ele.search_id,
              search_topic: ele?.search_type,
              is_saved: is_saved,
              alert_topic: alertTopic ? alertTopic + `(${index})` : "",
            });
          });
        const searchhistoryjson = multiple
          ? { data: multipleData }
          : {
              data: [
                {
                  usermaster_id: profileuser_id,
                  usersearchlog_id: usersearchlog_id,
                  search_topic: singleRow?.search_type,
                  is_saved: is_saved,
                  alert_topic: alertTopic ?? "",
                },
              ],
            };

        await savedSearchAlert({
          searchhistoryjson,
          profileuser_id,
        })
          .then((res) => {
            dispatch(updateSearchHistoryResults(res));
            dispatch(searchHistorySuccess(res));
          })
          .then(() => {
            fetchSearchHistory();
            notify("success", "Search Saved");
          });
        setSaveSearchModal(false);
        setMultiple(false);
        setAlertTopic("");
      } catch (err) {
        console.log(err);
      }
    } else {
      showIsProfileToast("Please login as Profile user to save the Search");
    }
  };

  const handleAlertTopic = (e: string) => {
    setAlertTopic(e);
  };

  const closeSaveSearchModal = () => {
    setSaveSearchModal(false);
  };

  const openSaveSearchModal = () => {
    if (sessionStorage.getItem("isProfileUser") !== "true") {
      showIsProfileToast("Please login as Profile user to save the Search");
      return;
    }
    setSaveSearchModal(true);
  };

  function openPrelimitFiltersInfoModal(props: {
    mouseOverData: string;
    searchType: string;
  }) {
    dispatch(
      setModal({
        modalType: "PRELIMIT_FILTERS_INFO_MODEL",
        modalProps: {
          isOpen: true,
          data: props,
        },
      }),
    );
  }

  return (
    <Stack sx={sx.historyTable}>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography sx={sx.heading}>Search History</Typography>
        {isAICustomer && (
          <Box
            sx={{
              display: "flex",
              // justifyContent: "flex-end",
              // mt: 1,
              // marginLeft: 10,
            }}
          >
            <RadioGroup
              row
              value={searchMode}
              onChange={(e) => setSearchMode(e.target.value as SearchMode)}
            >
              <FormControlLabel
                value="boolean"
                control={<Radio size="small" />}
                label="Boolean"
              />

              <FormControlLabel
                value="semantic"
                control={<Radio size="small" />}
                label={
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                    }}
                  >
                    AI Search
                    <Chip
                      label="Beta"
                      size="small"
                      sx={{
                        height: "18px",
                        fontSize: "10px",
                        backgroundColor: "#e8e0fa",
                        color: "#7852fb",
                      }}
                    />
                  </Box>
                }
              />
            </RadioGroup>
          </Box>
        )}
      </Box>
      {searchMode !== "semantic" && (
        <QueryBuilder searchHistory={searchHistory} />
      )}

      <Box
        sx={{
          alignSelf: "flex-end",
          paddingBottom: "17px",
          paddingTop: "10px",
        }}
      >
        <SplitButton searchMode={searchMode} />
      </Box>
      <Box sx={{ display: { xs: "none", sm: "initial" } }}>
        <TableContainer component={Paper}>
          <Table sx={{ width: "100%" }} aria-label="simple table">
            <TableHead sx={sx.tableHead}>
              <TableRow sx={{ backgroundColor: Colors.coolGray100 }}>
                {
                  <TableCell
                    sx={{
                      ...sx.BorderStyles,
                      paddingTop: "0px",
                      paddingBottom: "0px",
                    }}
                  >
                    <Checkbox
                      checked={
                        selectedSearches?.length > 0 &&
                        selectedSearches?.length ===
                          searchHistory?.filter(
                            (obj) => obj?.is_delete === false,
                          )?.length
                      }
                      onClick={handleSelectAll}
                    />
                  </TableCell>
                }
                <TableCell
                  sx={{
                    ...sx.BorderStyles,
                    textAlign: "center",
                    paddingTop: "0px",
                    paddingBottom: "0px",
                  }}
                >
                  {searchMode !== "semantic" ? (
                    <Typography>#</Typography>
                  ) : (
                    <Typography>#</Typography>
                  )}
                </TableCell>
                <TableCell
                  sx={{
                    ...sx.BorderStyles,
                    paddingTop: "0px",
                    paddingBottom: "0px",
                  }}
                >
                  <Typography>Search Term</Typography>
                </TableCell>
                <TableCell
                  sx={{
                    ...sx.BorderStyles,
                    paddingTop: "0px",
                    paddingBottom: "0px",
                  }}
                >
                  <Typography>Result Count</Typography>
                </TableCell>
                <TableCell
                  sx={{
                    ...sx.BorderStyles,
                    paddingTop: "0px",
                    paddingBottom: "0px",
                  }}
                >
                  <Typography>Date</Typography>
                </TableCell>

                {searchMode !== "semantic" && (
                  <TableCell
                    sx={{
                      ...sx.BorderStyles,
                      paddingTop: "0px",
                      paddingBottom: "0px",
                    }}
                  >
                    <Typography>Search Type</Typography>
                  </TableCell>
                )}

                <TableCell>
                  {selectedSearches.length > 0 && (
                    <Box sx={sx.actionBar}>
                      {/* for DF-2381 */}
                      {/* <IconButton
                      onClick={() => {
                        setMultiple(true);
                        openSaveSearchModal();
                      }}
                    >
                      <Save />
                    </IconButton> */}
                      <IconButton onClick={handleMultilpeDelete}>
                        <Delete />
                      </IconButton>
                    </Box>
                  )}
                </TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {searchHistory?.length > 0 ? (
                searchHistory
                  ?.filter((obj) => obj?.is_delete === false)
                  ?.map((row, index) => (
                    <TableRow key={index}>
                      {
                        <TableCell sx={sx.BorderStyles}>
                          <Checkbox
                            checked={selectedSearches
                              ?.map((item) => {
                                return item?.search_id;
                              })
                              ?.includes(row?.search_id)}
                            onClick={() => {
                              handleSelected(row);
                            }}
                          />
                        </TableCell>
                      }
                      <TableCell
                        component="th"
                        scope="row"
                        sx={{ ...sx.BorderStyles, textAlign: "center" }}
                      >
                        {searchMode !== "semantic" ? (
                          <Typography>{`#${row?.row_number}`}</Typography>
                        ) : (
                          <Typography>{`${row?.row_number}`}</Typography>
                        )}
                      </TableCell>
                      <TableCell
                        // onClick={() => {
                        //   handleKeywordClick(
                        //     row.SearchTerms,
                        //     row.search_url,
                        //     row?.search_type
                        //   );
                        //   setIsSearching(true);
                        //   setRowNumber(row?.row_number);
                        //   handleUsageLog(row?.search_type);
                        // }}
                        sx={{
                          ...sx.BorderStyles,
                          // cursor: "pointer",
                          width: "30% !important",
                        }}
                      >
                        <Typography>
                          {/* {removeDuplicateTerms(row.SearchTerms)} */}
                          {removeDuplicateTerms(row.ref_SearchTerms)}
                          {/* {row.SearchTerms.replace(
                        /author_address_fz:|title_fz:|keywords_fz:|author_all_fz:|issn:|articledoi:|resourcemaster_id:|yearfrom:/gi,
                        ""
                      )}{" "} */}
                          {/* ({row.result_count?.toLocaleString("en-US")}) */}
                        </Typography>
                      </TableCell>
                      <TableCell
                        onClick={() => {
                          dispatch(clearSearchedAuthor());
                          handleKeywordClick(
                            row.SearchTerms,
                            row.search_url,
                            row?.search_type,
                            row?.row_number,
                            row?.ai_user_query,
                          );
                          setIsSearching(true);
                          setRowNumber(row?.row_number);
                          handleUsageLog(row?.search_type);
                          dispatch(clearSJRandABDCFilters());
                        }}
                        sx={{
                          ...sx.BorderStyles,
                          ...sx.viewResult,
                          cursor: "pointer",
                          width: "20% !important",
                        }}
                      >
                        <Typography>
                          View Results{" "}
                          <span style={{ color: "#000", opacity: 0.8 }}>
                            ({row.result_count?.toLocaleString("en-US")})
                          </span>
                        </Typography>
                      </TableCell>
                      <TableCell sx={sx.BorderStyles}>
                        <Typography>
                          {" "}
                          {dayjs(row.createddate).format("MMM DD, YYYY")}
                        </Typography>
                      </TableCell>
                      {searchMode !== "semantic" && (
                        <TableCell sx={sx.BorderStyles}>
                          <Typography>
                            {" "}
                            {row.search_type === "Advanced Search"
                              ? "Search Builder"
                              : row.search_type}
                            {/* <CustomTooltip
                          title={"Prelimits applled:  " + row?.mouse_over_data}
                          arrow
                          placement="top"
                        >
                          <IconButton size="small">
                            <InfoOutlinedIcon fontSize="inherit" />
                          </IconButton>
                        </CustomTooltip> */}
                            {row?.mouse_over_data && (
                              <IconButton
                                size="medium"
                                // onClick={() =>
                                onClick={() =>
                                  openPrelimitFiltersInfoModal({
                                    mouseOverData: row?.mouse_over_data,
                                    searchType: row?.search_type,
                                  })
                                }
                              >
                                <InfoOutlinedIcon fontSize="inherit" />
                              </IconButton>
                            )}
                          </Typography>
                        </TableCell>
                      )}
                      <TableCell>
                        <Box sx={sx.actionBar}>
                          <Tooltip
                            title={
                              row.datalerttypeid > 0
                                ? "Modify Alert"
                                : "Set Alert"
                            }
                          >
                            <IconButton onClick={handleRSSClick(row)}>
                              <RSSIcon
                                sx={{
                                  color:
                                    row.datalerttypeid > 0 ? "#F48120" : "",
                                }}
                              />
                            </IconButton>
                          </Tooltip>
                          {/* <IconButton onClick={handleMenuClick(row)}>
                          <MoreVert />
                        </IconButton> */}
                          <Tooltip
                            title={row?.is_saved ? "Search Saved" : "Save"}
                          >
                            <IconButton
                              onClick={() => {
                                setSingleRow(row);
                                openSaveSearchModal();
                              }}
                              disabled={row?.is_saved ? true : false}
                            >
                              <Save />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete">
                            <IconButton onClick={() => handleSingleDelete(row)}>
                              <Delete />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                      {rowNumber && rowNumber === row.row_number && (
                        <TableCell>
                          <CircularProgress color="primary" size={28} />
                        </TableCell>
                      )}
                    </TableRow>
                  ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={searchMode !== "semantic" ? 7 : 6} // Adjust if your columns differ
                    align="center"
                  >
                    <Typography>No data available</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          <SearchHistoryMenu
            open={!!anchorEl}
            anchor={anchorEl}
            onClose={() => {
              setAnchorEl(null);
              setMultiple(false);
            }}
            selectedMenuHistory={selectedMenuHistory}
            refetch={fetchSearchHistory}
            multiple={multiple}
            selectedSearches={selectedSearches}
          />

          <SearchHistoryAlert
            selectedMenuHistory={selectedMenuHistory}
            open={openRSSModal}
            onClose={() => setOpenRSSModal(false)}
            refetch={fetchSearchHistory}
          />

          <SaveSearchModal
            open={saveSearchModal}
            headerText="Save the search"
            onClose={closeSaveSearchModal}
            handleSave={handleSaveSearchHistory}
            alertTopic={alertTopic}
            handleAlertTopicChange={handleAlertTopic}
          />
        </TableContainer>
      </Box>

      <Box sx={{ display: { xs: "initial", sm: "none" } }}>
        {searchHistory?.filter((obj) => !obj?.is_delete).length > 0 && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              marginLeft: "10px",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Checkbox
                checked={
                  selectedSearches?.length > 0 &&
                  selectedSearches?.length ===
                    searchHistory?.filter((obj) => obj?.is_delete === false)
                      ?.length
                }
                onClick={handleSelectAll}
              />
              <Typography>Select All</Typography>
            </Box>
            {selectedSearches.length > 0 && (
              <Box sx={sx.actionBar}>
                <IconButton onClick={handleMultilpeDelete}>
                  <Delete />
                </IconButton>
              </Box>
            )}
          </Box>
        )}
      </Box>

      <Box sx={{ display: { xs: "initial", sm: "none" } }}>
        {searchHistory?.length > 0 &&
          searchHistory
            .filter((obj) => obj?.is_delete === false)
            .map((row, index) => (
              <Box key={row.search_id || index} sx={webStyles.container}>
                <Box sx={webStyles.flexBox}>
                  <Box sx={{ width: { xs: "100%", sm: "90%" } }}>
                    {/* Top row: Checkbox + Search Term + Metadata */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 2,
                      }}
                    >
                      {/* Left: Checkbox + S1 */}
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          minWidth: "40px",
                        }}
                      >
                        <Checkbox
                          checked={selectedSearches
                            ?.map((item) => item?.search_id)
                            .includes(row?.search_id)}
                          onClick={() => handleSelected(row)}
                          sx={{ padding: "0 8px" }}
                        />
                        <Typography variant="body2">{`S${row?.row_number}`}</Typography>
                      </Box>

                      {/* Right: Search content */}
                      <Box>
                        {/* Search Term */}
                        <Typography
                          gutterBottom
                          sx={{
                            ...webStyles.text,
                            fontSize: "1rem",
                            fontFamily: "Lora",
                            fontWeight: 600,
                          }}
                          onClick={() => {
                            handleKeywordClick(
                              row.SearchTerms,
                              row.search_url,
                              row?.search_type,
                              row?.row_number,
                              row?.ai_user_query,
                            );
                            setIsSearching(true);
                            setRowNumber(row?.row_number);
                            handleUsageLog(row?.search_type);
                          }}
                        >
                          {removeDuplicateTerms(row.ref_SearchTerms)}
                        </Typography>

                        <Box sx={{ display: "flex", gap: 1 }}>
                          <Typography
                            sx={{
                              fontSize: "14px",
                              color: "gray",
                              width: "100px",
                            }}
                          >
                            Results:{" "}
                          </Typography>
                          <Typography sx={{ fontSize: "14px", color: "gray" }}>
                            {row.result_count?.toLocaleString("en-US")}
                          </Typography>
                        </Box>

                        {/* Date */}
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <Typography
                            sx={{
                              fontSize: "14px",
                              color: "gray",
                              width: "100px",
                            }}
                          >
                            Created on:{" "}
                          </Typography>
                          <Typography sx={{ fontSize: "14px", color: "gray" }}>
                            {dayjs(row.createddate).format("MMM DD, YYYY")}
                          </Typography>
                        </Box>

                        {/* Search Type */}
                        <Box
                          sx={{
                            display: "flex",
                            gap: 1,
                            alignItems: "baseline",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "14px",
                              color: "gray",
                              width: "100px",
                            }}
                          >
                            Search Type:
                          </Typography>
                          <Typography sx={{ fontSize: "14px", color: "gray" }}>
                            {row.search_type === "Advanced Search"
                              ? "Search Builder"
                              : row.search_type}
                            {row?.mouse_over_data && (
                              <IconButton
                                size="small"
                                onClick={() =>
                                  openPrelimitFiltersInfoModal({
                                    mouseOverData: row?.mouse_over_data,
                                    searchType: row?.search_type,
                                  })
                                }
                              >
                                <InfoOutlinedIcon fontSize="inherit" />
                              </IconButton>
                            )}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>

                    {/* Action buttons */}
                    <Box sx={sx.actionBar}>
                      <Tooltip
                        title={
                          row.datalerttypeid > 0 ? "Modify Alert" : "Set Alert"
                        }
                      >
                        <IconButton onClick={handleRSSClick(row)}>
                          <RSSIcon
                            sx={{
                              color: row.datalerttypeid > 0 ? "#F48120" : "",
                            }}
                          />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title={row?.is_saved ? "Search Saved" : "Save"}>
                        <IconButton
                          onClick={() => {
                            setSingleRow(row);
                            openSaveSearchModal();
                          }}
                          disabled={!!row?.is_saved}
                        >
                          <Save />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Delete">
                        <IconButton onClick={() => handleSingleDelete(row)}>
                          <Delete />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </Box>
                </Box>
              </Box>
            ))}
      </Box>
    </Stack>
  );
};
export default HistoryTable;

const webStyles = {
  flexBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  button: {
    // margin: "0.5%",
  },
  container: {
    backgroundColor: Colors.white,
    padding: "2%",
    borderRadius: 4,
    borderWidth: 1,
    borderColor: "red",
    marginTop: "1%",
    cursor: "pointer",
    border: "2px solid gray",
  },
  text: {
    fontFamile: "Lora",
  },
  subText: {
    color: Colors.gray_600,
    fontFamily: "Helvetica Neue",
    fontSize: "0.8rem",
  },
  gridStyle: {
    position: "absolute",
    width: "330px",
    // height: "118px",
    right: "1px",
    top: "5px",
    marginTop: "50px",
    background: "#FFFFFF",
    border: "1px dashed rgba(33, 33, 33, 0.1)",
    boxShadow: "4px 4px 20px rgba(0, 0, 0, 0.06)",
    borderRadius: "6px",
    dispay: "flex",
    justifyContent: "flex-end",
    zIndex: "100000",
  },
};
